import React from "react";
import i18n from "utils/i18n";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import TabbedContent from 'components/molecules/TabbedContent'
import ViewOffice from 'scenes/management/statistics/views/ViewOffice'
import ViewUsage from 'scenes/management/statistics/views/ViewUsage'
import { useSelector } from 'react-redux'
import { formatDateRange } from 'components/atoms/GraphDateRange'
import { getChartDateRange } from 'services/redux/management/reducers'
import { useShowHamburger } from 'utils/helper-device'

const ManagementStatisticsIndexScene = () => {
	const showHamburger = useShowHamburger();
	
	const _graphDateRange = useSelector( state => {
		return getChartDateRange(state);
	} )

	const tabBarItems = [
		{
			key: 'office',
			text: i18n.t('management:charts.tabs.office'),
			scene: ( props ) => {
				return (
					<ViewOffice
						{...props}
					/>
				);
			}
		},
		{
			key: 'usage',
			text: i18n.t('management:charts.tabs.usage'),
			scene: ( props ) => {
				return (
					<ViewUsage
						{...props}
					/>
				);
			}
		}
	];
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={i18n.t('management:pages.statistics.index.title')}
				topNavigation={true}
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}>
				
				<TabbedContent
					items={ tabBarItems }
					props={{
						dateRange: formatDateRange( _graphDateRange )
					}}
				/>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

export default ManagementStatisticsIndexScene
